import React from 'react';
import axios from 'axios';
import PageWrapper from '@/components/SupportSection/shared/PageWrapper';
import { WordPressAPI } from '@/config';
import { FaqStyles } from '@/components/SupportSection/Faq/FaqStyles';
import FaqSection from '@/components/SupportSection/Faq/FaqSection';

const FAQPage = ({ data }) => (
  <PageWrapper data={data.acf} breadcrumb={data.acf.page_title_tag}>
    <FaqStyles>
      <h1>{data.acf.page_title_tag}</h1>
      <div className='sections'>
        {
          data.acf.sections.length ? data.acf.sections.map((section) => {
            return (
              <FaqSection data={section} />
            )
          })
            : ''
        }
      </div>
    </FaqStyles>
  </PageWrapper>
);

export async function getServerSideProps({ params, res }) {
  const result = await axios.get(`${WordPressAPI.pages}?slug=${params.slug}`);

  if (!result.data.length){
    res.status(404).redirect('/support');
    return false
  } 
  
  return {
    props: {
      data: result.data[0],
    },
  };
}

export default FAQPage;
